import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { LegendCont, ScoreBar, ScoreCont, ScoreText, ScoresCont } from './Legend.styles';
import { EScoreRating } from '../../../../services/individualReport';

const Legend = () => {
  const theme = useTheme();
  const { t } = useTranslation();

  const colors: Record<EScoreRating, string> = {
    [EScoreRating.STRONG]: theme.colors.accent.green[100],
    [EScoreRating.NORMAL]: theme.colors.accent.blue[100],
    [EScoreRating.WEAK]: theme.colors.accent.red[100],
  };

  return (
    <LegendCont id="LegendCont">
      <ScoresCont id="ScoresCont">
        {Object.values(EScoreRating).map(level => (
          <ScoreCont id="ScoreCont" key={level}>
            <ScoreBar id="ScoreBar" background={colors[level]} />
            <ScoreText>{t(`results.report.pdf.legend.${level}`)}</ScoreText>
          </ScoreCont>
        ))}
      </ScoresCont>
    </LegendCont>
  );
};

export default Legend;
